<template>
  <section>
    <header>
      <h1 class="page-header">Account</h1>
    </header>
    <p><strong>Email</strong>: {{ user.email }}</p>
    <hr v-if='!sso'>
    <p v-if="!sso"><router-link to="/change-password">Change password</router-link></p>
    <section v-if="user.auth.includes('basic')">
      <hr>
      <p>You have purchased the basic version of Six Plus Hold’em. If you would like to upgrade to the premium plan for another $50, head over to the <router-link to="/upgrade">upgrade page</router-link>.</p>
    </section>
    <section v-if="user.auth.includes('premium')">
      <hr>
      <p>You have purchased the premium version of Six Plus Hold’em.</p>
    </section>
    <section v-if="user.auth.includes('short deck')">
      <hr>
      <p>You have purchased the short deck hit calculator.</p>
    </section>
    <section v-if="!user.auth.includes('short deck') || !user.auth.includes('premium')">
      <hr>
      <section v-if="daysLeftOnFreeTrial > 0">
        <p><strong>Days left on free trial:</strong> {{ daysLeftOnFreeTrial }}</p>
        <p v-if="!user.auth.includes('basic') && !user.auth.includes('premium')">If you're ready to purchase, head over to the <router-link to="/purchase">purchase page</router-link>.</p>
      </section>
      <section v-else>
        <p><em>
          Your free trial is over.
          <span v-if="!user.auth.includes('basic') && !user.auth.includes('premium')">You'll need to <router-link to="/purchase">purchase</router-link> the basic or premium version to continue using Six Plus Hold’em.</span>
        </em></p>
      </section>
    </section>
    <section v-if="!user.auth.includes('short deck')">
      <hr>
      <p><router-link to="/purchase-short-deck">Purchase page</router-link> for the short deck hit calculator.</p>
    </section>
    <hr>
    <p v-if="user.emailOptIn">
      You are currently subscribed to receive infrequent emails.
      <button
        class="btn btn-default btn-lg"
        v-bind:disabled="requestPending"
        v-on:click="unsubscribeFromEmail()"
      >
        {{ unsubscribeFromEmailText }}
      </button>
    </p>
    <div v-if="!user.emailOptIn">
      <p><strong>You have not subscribed to receive infrequent emails.</strong> It would be really cool if you did though. Some examples of the sorts of emails you'd get:</p>
      <ul>
        <li>Important new features</li>
        <li>"What feature should I build next?"-type questions</li>
      </ul>
      <p>No spam or other bullshit.</p>
      <button
        class="btn btn-default btn-lg"
        v-bind:disabled="requestPending"
        v-on:click="subscribeToEmail()"
      >
        {{ subscribeToEmailText }}
      </button>
    </div>
    <hr>
    <saved-scenarios
      v-bind:savedScenarios="user.savedScenarios"
    />
    <hr>
    <button
      class="btn btn-danger btn-lg"
      v-bind:disabled="requestPending"
      v-on:click="deleteAccount()"
    >
      {{ deleteAccountText }}
    </button>
  </section>
</template>

<script>
import SavedScenarios from '@/components/user/saved-scenarios';
import utilities from '@/services/utilities/utilities';
import _ from 'lodash';

export default {
  name: 'ppt-account',
  components: {
    'saved-scenarios': SavedScenarios,
  },
  data: function () {
    return {
      requestPending: false,
    };
  },
  computed: {
    user: function () {
      return this.$store.state.account.user;
    },
    daysLeftOnFreeTrial: function () {
      return this.$store.getters['account/daysLeftOnFreeTrial'];
    },
    paid: function () {
      return this.$store.getters['account/paid'];
    },
    sso: function () {
      return (this.user.googleId || this.user.twitterId || this.user.linkedinId);
    },
    unsubscribeFromEmailText: function () {
      if (this.requestPending === 'unsubscribe to email') {
        return 'Unsubscribing...';
      }

      return 'Unsubscribe';
    },
    subscribeToEmailText: function () {
      if (this.requestPending === 'subscribe to email') {
        return 'Subscribing...';
      }

      return 'Subscribe';
    },
    deleteAccountText: function () {
      if (this.requestPending === 'delete account') {
        return 'Deleting account...';
      }

      return 'Delete account';
    },
  },
  methods: {
    subscribeToEmail: function () {
      let self = this;

      self.requestPending = 'subscribe to email';
      self.$http
        .patch(`${process.env.BASE_API_URL}/user/subscribe-to-email`)
        .then(function () {
          self.requestPending = false;
          self.$store.commit('account/subscribeToEmail');
          alert('Successfully subscribed!');
        })
        .catch(function () {
          self.requestPending = false;
          alert('Error. Unable to subscribe. Email contact@sixplusholdem.com for help.');
        })
      ;
    },
    unsubscribeFromEmail: function () {
      let self = this;

      self.requestPending = 'unsubscribe to email';
      self.$http
        .patch(`${process.env.BASE_API_URL}/user/unsubscribe-from-email`)
        .then(function () {
          self.requestPending = false;
          self.$store.commit('account/unsubscribeFromEmail');
          alert('Successfully unsubscribed.');
        })
        .catch(function () {
          self.requestPending = false;
          alert('Error. Unable to unsubscribe. Email contact@sixplusholdem.com for help.');
        })
      ;
    },
    deleteAccount: function () {
      let self = this;
      let areYouSure = this._checkIfUserIsSure();

      if (!areYouSure) {
        return;
      }

      self.requestPending = 'delete account';
      self.$http
        .delete(`${process.env.BASE_API_URL}/user`)
        .then(function () {
          self.requestPending = false;
          self.$store.dispatch('account/clearUser');
          self.$router.push({ path: '/' });
          alert('Successfully deleted account.');
        })
        .catch(function () {
          self.requestPending = false;
          alert('Error. Unable to delete account. Email contact@sixplusholdem.com for help.');
        })
      ;
    },
    _checkIfUserIsSure: function () {
      let confirmText = 'Are you sure you want to delete your account?';

      if (this.paid) {
        confirmText += ' Note: by deleting your account you will lose access to what you have paid for.';
      }

      return confirm(confirmText);
    },
  },
};
</script>

<style lang="scss" scoped>
  section, p {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/account.vue